const urlHost = 'https://www.cms.netbell.ru';

export default urlHost
//https://tsaplineducation.ru
//https://www.cms.netbell.ru
